import React from "react";
import { Check, X } from "lucide-react";

import { CampaignActivityTableActions } from "./CampaignActivityTableActions";

export const getCampaignActivityTableColumns = () => {
  return [
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      width: 60,
      cell: ({ row }) => (
        <p style={{ fontWeight: "bold" }}>{row.original?.id}</p>
      ),
    },
    {
      header: "Campaign Activity ID",
      id: "Campaign Activity ID",
      accessorKey: "cc_campaign_activity_id",
    },
    {
      header: "Name",
      id: "Name",
      accessorKey: "name",
      cell: ({ row }) => row.original?.name ?? "—",
    },
    {
      header: "Account",
      id: "Account",
      accessorKey: "account.email_address",
    },
    {
      header: "Campaign",
      id: "Campaign",
      accessorKey: "campaign.name",
    },
    {
      header: "Email Template",
      id: "Email Template",
      accessorKey: "template.name",
    },
    {
      header: "Active",
      id: "Active",
      accessorKey: "active",
      cell: ({ row }) =>
        row.original?.active ? (
          <Check className="tw:size-4 tw:text-success" aria-label="Active" />
        ) : (
          <X className="tw:size-4 tw:text-destructive" aria-label="Inactive" />
        ),
    },
    {
      header: <div></div>,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      size: 60,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => (
        <CampaignActivityTableActions original={row.original} />
      ),
    },
  ];
};
